import React, { ReactElement } from "react";
import FeedbackTypeList from "../../components/FeedbackType";
import Layout from "../../components/layout";

const FeedbackTypePage = (): ReactElement => {
  return (
    <Layout>
      <FeedbackTypeList />
    </Layout>
  );
};

export default FeedbackTypePage;
